var isSupport = typeof window !== 'undefined';
var cookies = null;
if (isSupport) {
  cookies = require('js-cookie');
}

class Cookie {
  static isSupported() {
    return isSupport;
  }

  constructor(options) {
    this.cookieBaseDomain = options.cookieBaseDomain;
    this.secure = options.secure === true;
    this.expiration = options.expiration || null;
  }

  getItem(key) {
    var value = null;
    if (isSupport) {
      value = cookies.get(key);
    }
    return value;
  }

  setItem(key, value) {
    if (isSupport) {
      var expires = this.expiration || 20 * 365;
      cookies.set(key, value, {
        path: '/',
        domain: this.cookieBaseDomain,
        expires: expires,
        secure: this.secure
      });
    }
  }

  removeItem(key, domain) {
    if (isSupport) {
      cookies.remove(key, {
        path: '/',
        domain: domain || this.cookieBaseDomain,
        secure: this.secure
      });
    }
  }
}

export default Cookie;
